import BaseModelFMVStatementFootnote from "@/models/BaseModelFMVStatementFootnote.js";

export const GridConfig = {
    list: BaseModelFMVStatementFootnote.list,
	columns:BaseModelFMVStatementFootnote.columns ,
	grid: {
		gridId:'FMVStatementFootnoteGrid',
		checkbox: true,
		edit: true,
		delete: true,
		document: false,
		groupable: true,
	}
}

export const ToolBarConfig = {
	list: 'ToolBarItems',
	items: [                      
		{
				id:"btnAddFMVStatementfootnote",
				type: "button",
				text: "Tag Footnote",
				showIcon: "toolbar",
				icon:"toolbar-float",
				attributes: { "class": "float-right-btn btn btn-primary" },					
		},
		{
			id:"btnAddFootnote",
			type: "button",
			text: "Add Footnote",
			showIcon: "toolbar",
			icon:"plus-circle",
			attributes: { "class": "float-right-btn btn btn-secondary" },
		},  
		{
			id:"btnRollForwardFootnotes",
			type: "button",
			text: "Roll Forward Footnotes",
			showIcon: "toolbar",
			icon:"calendar-date",
			attributes: { "class": "float-right-btn btn btn-secondary" },					
		} 
	]
}